import { combineReducers } from 'redux';
import { responsiveStateReducer } from 'redux-responsive';
import { reducer as formReducer } from 'redux-form';
import user from './userReducer';
import map from './mapReducer';
import parkingSpots from './parkingSpotsReducer';
import navOptions from './navOptionsReducer';
import userAccommodationInfo from './userAccommodationReducer';
import mapAccommodationInfo from './mapAccommodationReducer';
import checkout from './checkoutReducer';
import search from './searchReducer';
import geoJsonData from './geoJsonDataReducer';
import pusher from './pusherReducer';
import session from './sessionReducer';
import storage from './storageReducer';

// this we are not saving this reducers to localStorage;
export const sessionOnlyReducers = ['form', 'browser', 'pusher', 'navOptions', 'session', 'geoJsonData'];

const rootReducer = combineReducers({
  // below are persisted in local Storage reducers;
  map,
  user,
  userAccommodationInfo,
  mapAccommodationInfo,
  checkout,
  search,
  storage,
  parkingSpots,

  // below are session only reducers
  form: formReducer,
  browser: responsiveStateReducer,
  geoJsonData,
  pusher,
  navOptions,
  session
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js